import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Page not found' },
  goHome: { defaultMessage: 'Go back home' },
});
